module.exports = __webpack_public_path__ + "media/images/countryrect/mr-8806facaf811ff21a611ca4e69f6ee3b.svg";